import styled, { css } from "styled-components";
import { ProductCardButtonVariant } from "../components/ProductButton";

interface StyleProps {
  $variant: ProductCardButtonVariant;
}

const highlightVariant = css`
  width: 100%;
  margin-top: 10px;
  border: none;

  @media (max-width: 700px) {
    padding: 10px 20px;
    border-radius: 32px;
    margin-right: 5px;
    color: white;
    height: 52px;
    max-width: 175px;
  }
`;
const modalVariant = css`
  background: var(--live-button-color) !important;
  font-size: 17px;
  letter-spacing: 1.5px;
  font-weight: 300;
`;

function getVariant(variant: ProductCardButtonVariant) {
  if (variant === "highlight") return highlightVariant;
  if (variant === "modal") return modalVariant;
  return "";
}

export const ButtonProduct = styled.button<StyleProps>`
  align-self: flex-end;
  border-radius: 21.5px;
  border: none;
  height: 43px;
  width: 100%;
  margin-top: 30px;
  color: white;
  z-index: 5;
  background-color: var(--live-button-color);
  &:hover {
    cursor: pointer;
  }

  & a {
    pointer-events: none;
    color: #fff;
    text-decoration: none;
  }

  ${({ $variant }) => getVariant($variant)}
`;
